import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Flex, Form, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { useRoleValue } from 'context';
import { createRole, updateRole } from 'services';
import { PATHNAME } from 'utils';

import { RoleFormAction } from './action';
import { RoleFormContent } from './content';

const {
  LOCAL: {
    ROLES: { BASE_URL: ROLES_BASE_URL },
  },
} = PATHNAME;

type FieldType = Pick<ReturnType<typeof useRoleValue>, 'name' | 'scopes'>;

const RoleForm = () => {
  const [form] = Form.useForm<FieldType>();
  const { id = '', defaultName, mode } = useRoleValue();
  const navigate = useNavigate();

  const onFinish = useLockFn(async ({ name = '', scopes = [] }: FieldType) => {
    const isUpdatedMode = mode === 'Update';

    const params: Parameters<typeof updateRole>[0] = {
      id,
    };
    const body: Parameters<typeof updateRole>[1] = {
      name,
      scopes,
    };

    (isUpdatedMode ? updateRole(params, body) : createRole(body))
      .then(() => {
        notification.success({
          message: `دسترسی ${isUpdatedMode ? defaultName : name} با موفقیت ${isUpdatedMode ? 'ویرایش' : 'ساخته'} شد.`,
        });
        navigate(ROLES_BASE_URL);
      })
      .catch(message => {
        notification.error({ message });
      });
  });

  return (
    <PrimitiveForm form={form} onFinish={onFinish}>
      <Flex
        className='*:rounded *:bg-white max-xl:flex-col max-xl:last:*:sticky max-xl:last:*:inset-x-0 max-xl:last:*:bottom-0 max-xl:last:*:z-10 max-xl:last:*:shadow-inner xl:items-start xl:first:*:basis-[70%] xl:last:*:basis-[30%]'
        gap='large'
      >
        <RoleFormContent />
        <RoleFormAction />
      </Flex>
    </PrimitiveForm>
  );
};

export { RoleForm };
